import { Builder } from '@builder.io/react';
import { FC } from 'react';

import Heading from 'molecules/Heading';
import Section from 'molecules/Section';
import { splitSectionProps } from 'molecules/Section/config';

import { ComponentHeadingConfigProps } from 'components/Heading/config';

import { headingPlainText } from 'utils/strings/HeadingHighlights';

const ComponentHeading: FC<ComponentHeadingConfigProps> = props => {
  const { sectionProps, rest } = splitSectionProps(props);

  if (rest.visuallyHidden) {
    // SEO-only heading for pages whose visible title is an image (e.g. the
    // Connect logo): crawlers read it, visitors never see it, and the Section
    // wrapper is skipped so no empty spacing is left behind.
    const HeadingTag = (rest.as || 'h1') as keyof JSX.IntrinsicElements;
    const text = headingPlainText(rest.heading || '');

    if (!text) {
      return null;
    }

    if (Builder.isEditing) {
      return (
        <div className="border border-dashed border-primary-300 p-2 text-sm text-gray-300">
          Hidden {String(rest.as || 'h1').toUpperCase()} (visible only to search engines): {text}
        </div>
      );
    }

    return <HeadingTag className="sr-only">{text}</HeadingTag>;
  }

  return (
    <Section {...sectionProps}>
      <Heading {...rest} />
    </Section>
  );
};

export default ComponentHeading;
